import { Injectable, EventEmitter } from '@angular/core';
/**
 * An abstract base class that implements
 * the Internationalization service methods
 * for the current locale.
 */
export class IntlService {
    constructor() {
        /**
         * @hidden
         */
        this.changes = new EventEmitter();
    }
    /**
     * Notifies that the service was changed.
     */
    notify() {
        this.changes.emit();
    }
}
IntlService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
IntlService.ctorParameters = () => [];
